import type { FaireProductEntity } from "../../entity_types/product";

export const p_fae2f6x6eb: FaireProductEntity = {
  token: "p_fae2f6x6eb",
  type: "product",
  name: "Paper Airplane Love and Friendship Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2c02bc5d3bee5c707aee3f7e695c6c73343b80e3c9f943b861b6fcad22ab195f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba23ce9a891fe07708c243eb889305e0ab0a9e3ebece93090cc21bac1e7542b8.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Please come close enough where my 4-foot range plane will lovingly (annoyingly?) enter your airspace.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:31.485Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
